<template>
  <b-modal
    id="modal-tambah-kategori"
    v-model="isVisible"
    hide-footer
    hide-header
    hide-header-close
    no-close-on-esc
    centered
    @hidden="onHidden"
  >
    <div class="flex items-center justify-between mb-[24px] mt-[12px]">
      <span class="font-semibold text-[18px] text-[#333333]">Tambah Kategori</span>
      <b-button
        variant="ghost"
        class="!p-0 !text-[32px] text-[#292D32] rotate-45"
        @click="onCancel"
      >
        <span class="k-add" />
      </b-button>
    </div>
    <b-form @submit.prevent="onSubmit">
      <b-form-group class="mb-[24px]">
        <label class="font-medium text-[14px] text-[#333333] mb-[6px] block">
          Nama Kategori<span class="text-[#F95031]">*</span>
        </label>
        <b-form-input
          v-model="form.nama"
          placeholder="Masukkan nama kategori"
          maxlength="30"
          class="!rounded-[8px]"
        />
        <div class="flex items-center justify-between mt-[4px] mb-[12px]">
          <span
            class="flex items-center gap-[4px] text-[12px]"
            :class="showUniqueError ? 'text-[#F95031]' : 'text-[#828282]'"
          >
            <span class="k-danger text-[14px]" />
            {{ showUniqueError ? 'Nama kategori sudah digunakan.' : 'Nama kategori harus unik' }}
          </span>
          <span class="text-[12px] text-[#626262]">{{ form.nama.length }}/30</span>
        </div>
      </b-form-group>

      <div class="flex gap-[12px] mt-[8px] mb-[12px]">
        <b-button
          variant="outline-secondary"
          class="flex-1 !rounded-[8px]"
          @click="onCancel"
        >
          Batal
        </b-button>
        <b-button
          type="submit"
          variant="primary"
          class="flex-1 !rounded-[8px] btn-tambahkan"
          :disabled="!isFormValid || isLoading"
          @click.prevent="onSubmit"
        >
          <b-spinner
            v-if="isLoading"
            small
            class="mr-1"
          />
          Tambahkan
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalTambahKategori',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    existingNames: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      form: {
        nama: '',
      },
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    isDuplicate() {
      const trimmed = this.form.nama.trim().toLowerCase()
      return this.existingNames.some(n => n.toLowerCase() === trimmed)
    },
    showUniqueError() {
      return this.form.nama.trim().length > 0 && this.isDuplicate
    },
    isFormValid() {
      return this.form.nama.trim().length > 0 && !this.isDuplicate
    },
  },
  methods: {
    async onSubmit() {
      if (!this.isFormValid || this.isLoading) return
      const label = this.form.nama.trim()
      const value = label.toLowerCase().replace(/\s+/g, '_')
      this.isLoading = true
      try {
        await this.$http_new.post('/komclass/api/v1/komlabs/campaigns/options', {
          option_type: 'product_category',
          option_value: value,
          option_label: label,
        })
        if (this.$toast_success) {
          this.$toast_success({ message: 'Kategori berhasil ditambahkan.' })
        }
        this.$emit('success')
        this.isVisible = false
      } catch (error) {
        if (this.$toast_error) {
          this.$toast_error({ message: 'Gagal menambahkan kategori.' })
        }
      } finally {
        this.isLoading = false
      }
    },
    onCancel() {
      this.isVisible = false
    },
    onHidden() {
      this.form.nama = ''
    },
  },
}
</script>

<style scoped>
/* Tombol Tambahkan tetap oranye saat disabled, hanya opacity berkurang */
:deep(.btn-tambahkan:disabled),
:deep(.btn-tambahkan.disabled) {
  background-color: #F95031 !important;
  border-color: #F95031 !important;
  opacity: 0.5;
}
</style>
